import Actions from 'flow/actions';
import LicensesResource from 'flow/api/licenses';
import FlowResource from 'flow/api/flow';

import { httpGetErrorDispatcher } from 'flow/actions/app-actions';

export const fetchExtensionLicenseDescriptions = () => (dispatch) => {
    LicensesResource.getLicenseDescriptions({
        onResult(json) {
            dispatch(receiveExtensionLicenseDescriptions(json));
        },
        onError: httpGetErrorDispatcher(dispatch),
    });
};

export const fetchPbxLicense = () => (dispatch) => {
    FlowResource.getCurrentPbxLicense({
        onResult(json) {
            dispatch(receivePbxLicense(json));
        },
        onError: httpGetErrorDispatcher(dispatch),
    });
};

export const receiveExtensionLicenseDescriptions = (licenseDescriptions) => ({
    type: Actions.RESULT_LICENSE_DESCRIPTION,
    data: licenseDescriptions,
});

export const receivePbxLicense = (nbrLicences) => ({
    type: Actions.RESULT_PBX_LICENSE,
    data: nbrLicences,
});
